/** Field bounds, mirroring the backend's `GenerationItemCreate` validators. */
export const ITEM_TITLE_MAX_LENGTH = 60;
export const ITEM_SUBTITLE_MAX_LENGTH = 80;
export const ITEM_VALUE_MAX_LENGTH = 20;

/** One row of the pack form, keyed locally so reorders keep their inputs. */
export interface PackItemEntry {
  key: string;
  title: string;
  subtitle: string;
  value: string;
  asset_id: string | null;
}

let nextKey = 0;

export function emptyItemEntry(): PackItemEntry {
  nextKey += 1;
  return { key: `item-${nextKey}`, title: '', subtitle: '', value: '', asset_id: null };
}
